/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyModel } from '../../models/client-survey-model';

export interface GetSurvey$Plain$Params {

/**
 * survey id filter
 */
  surveyId: number;
}

export function getSurvey$Plain(http: HttpClient, rootUrl: string, params: GetSurvey$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyModel>> {
  const rb = new RequestBuilder(rootUrl, getSurvey$Plain.PATH, 'get');
  if (params) {
    rb.path('surveyId', params.surveyId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientSurveyModel>;
    })
  );
}

getSurvey$Plain.PATH = '/api/Survey/{surveyId}';
